export function isPlainObject(value: unknown): boolean {
    return typeof value === 'object' && value instanceof Object && !(value instanceof Array);
}
